import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import AvantiAccess from '../plugins/access'

import store from '../store'
import { USER_REQUEST } from '../store/actions/user'
import { SET_PAGE_LOADING } from '../store/actions/states'

import PageNotFound from '../components/404'

import UserLogin from '../components/Guest/UserLogin'
import UserVerify from '../components/Guest/UserVerify'
import UserPasswordForgot from '../components/Guest/UserPasswordForgot'
import UserPasswordReset from '../components/Guest/UserPasswordReset'

import SearchObject from '../components/Admin/Search/SearchObject'
import SearchCustomer from '../components/Admin/Search/SearchCustomer'

import Dashboard from '../components/Admin/Dashboard/Dashboard'
import DashboardPageOverview from '../components/Admin/Dashboard/PageOverview'
import DashboardPageUferdigeKontrakt from '../components/Admin/Dashboard/PageUferdigeKontrakt'
import DashboardPageUferdigeObjekt from '../components/Admin/Dashboard/PageUferdigeObjekt'
import DashboardPageOppgaver from '../components/Admin/Dashboard/PageOppgaver'
import DashboardPageFailedOppgjor from '../components/Admin/Dashboard/PageFailedOppgjor'
// import UserProfile from '../components/Admin/UserProfile'

import Instillinger from '../components/Admin/Instillinger/Instillinger'
import InstillingerList from '../components/Admin/Instillinger/InstillingerList'
import InstillingerTypeList from '../components/Admin/Instillinger/InstillingerTypeList'
import InstillingerTypeEdit from '../components/Admin/Instillinger/InstillingerTypeEdit'
import InstillingerCustomList from '../components/Admin/Instillinger/InstillingerCustomList'
import InstillingerBetalingsartEdit from '../components/Admin/Instillinger/InstillingerBetalingsartEdit'
import InstillingerBokforgruppeEdit from '../components/Admin/Instillinger/InstillingerBokforgruppeEdit'
import InstillingerFraktgruppeEdit from '../components/Admin/Instillinger/InstillingerFraktgruppeEdit'
import InstillingerFreighttypeEdit from '../components/Admin/Instillinger/InstillingerFreighttypeEdit'
import InstillingerUtelagringsdagerEdit from '../components/Admin/Instillinger/InstillingerUtelagringsdagerEdit'
import InstillingerLegitimasjonEdit from '../components/Admin/Instillinger/InstillingerLegitimasjonEdit'
import InstillingerLokasjonEdit from '../components/Admin/Instillinger/InstillingerLokasjonEdit'
import InstillingerMvaEdit from '../components/Admin/Instillinger/InstillingerMvaEdit'
import InstillingerObjektbeskrivelseEdit from '../components/Admin/Instillinger/InstillingerObjektbeskrivelseEdit'
import InstillingerObjektsignertEdit from '../components/Admin/Instillinger/InstillingerObjektsignertEdit'
import InstillingerVareenhetEdit from '../components/Admin/Instillinger/InstillingerVareenhetEdit'
import InstillingerVareEdit from '../components/Admin/Instillinger/InstillingerVareEdit'
import InstillingerKundekategoritypeEdit from '../components/Admin/Instillinger/InstillingerKundekategoritypeEdit'
import InstillingerDokumenttypeEdit from '../components/Admin/Instillinger/InstillingerDokumenttypeEdit'

import InstillingerKategoriEdit from '../components/Admin/Instillinger/InstillingerKategoriEdit'
import InstillingerLandEdit from '../components/Admin/Instillinger/InstillingerLandEdit'
import InstillingerExpertavdelingEdit from '../components/Admin/Instillinger/InstillingerExpertavdelingEdit'
import InstillingerMerknadEdit from '../components/Admin/Instillinger/InstillingerMerknadEdit'
import InstillingerPrinterEdit from '../components/Admin/Instillinger/InstillingerPrinterEdit'
import InstillingerBilagsoverforingEdit from '../components/Admin/Instillinger/InstillingerBilagsoverforingEdit'
import InstillingerOppgjordebugEdit from '../components/Admin/Instillinger/InstillingerOppgjordebugEdit'
import InstillingerKunstnerEdit from '../components/Admin/Instillinger/InstillingerKunstnerEdit'
import InstillingerAuksjonList from '../components/Admin/Instillinger/InstillingerAuksjonList'
import InstillingerAuksjonEdit from '../components/Admin/Instillinger/InstillingerAuksjonEdit'
import InstillingerAutochargeintervalEdit from '../components/Admin/Instillinger/InstillingerAutochargeintervalEdit'

// import InstillingerLabelEdit from '../components/Admin/Instillinger/InstillingerLabelEdit'
import InstillingerLabel from '../components/Admin/Instillinger/Label/Label'
import InstillingerLabelArt from '../components/Admin/Instillinger/Label/LabelArt'
import InstillingerLabelWine from '../components/Admin/Instillinger/Label/LabelWine'

import Kunde from '../components/Admin/Kunde'
import KundeList from '../components/Admin/KundeList'
import KundeCard from '../components/Admin/KundeCard'
import KundeCardAdd from '../components/Admin/KundeCardAdd'
import KundeKontraktObjektFullscreen from '../components/Admin/KundeKontraktObjektFullscreen'

import Bruker from '../components/Admin/Bruker'
import BrukerList from '../components/Admin/BrukerList'
import BrukerCard from '../components/Admin/BrukerCard'
import BrukerCardAdd from '../components/Admin/BrukerCardAdd'
import Playground from '../components/Admin/Playground'
import SearchRedirect from '../components/Admin/SearchRedirect'

import Reports from '../components/Admin/Reports/Reports'
import ReportsList from '../components/Admin/Reports/ReportsList'
import RSLink from '../components/Admin/Reports/RSLink'

import Resultatbrev from '../components/Admin/Reports/Resultatbrev'
import ResultatbrevHistorikk from '../components/Admin/Reports/ResultatbrevHistorikk'
import ResultatbrevUbehandlade from '../components/Admin/Reports/ResultatbrevUbehandlade'
import ResultatbrevGodkjenning from '../components/Admin/Reports/ResultatbrevGodkjenning'
import ResultatbrevNy from '../components/Admin/Reports/ResultatbrevNy'

import Bekreftelsebrev from '../components/Admin/Reports/Bekreftelsebrev'
import BekreftelsebrevHistorikk from '../components/Admin/Reports/BekreftelsebrevHistorikk'
import BekreftelsebrevUbehandlade from '../components/Admin/Reports/BekreftelsebrevUbehandlade'
import BekreftelsebrevGodkjenning from '../components/Admin/Reports/BekreftelsebrevGodkjenning'
import BekreftelsebrevNy from '../components/Admin/Reports/BekreftelsebrevNy'

import Katalog from '../components/Admin/Reports/Katalog'
import KatalogKundeList from '../components/Admin/Reports/KatalogKundeList'

import Besiktigelse from '../components/Admin/Reports/Besiktigelse'
import BesiktigelseList from '../components/Admin/Reports/BesiktigelseList'

import Manuslist from '../components/Admin/Reports/Manuslist'
import ManuslistGenerator from '../components/Admin/Reports/ManuslistGenerator'

import Politirapport from '../components/Admin/Reports/Politirapport'
import PolitirapportGenerator from '../components/Admin/Reports/PolitirapportGenerator'
import GjenstanderKlareForAuksjon from '../components/Admin/Reports/GjenstanderKlareForAuksjon'
import Vinpakkeliste from '../components/Admin/Reports/Vinpakkeliste'

import ObjektFinder from '../components/Admin/ObjektFinder'

import Auctions from '../components/Admin/Auctions/Auctions'
import AuctionsList from '../components/Admin/Auctions/AuctionsList'
import Forhandsbud from '../components/Admin/Auctions/Forhandsbud/Forhandsbud'
import Spader from '../components/Admin/Auctions/Spader/Spader'
import Telefonbud from '../components/Admin/Auctions/Telefonbud/Telefonbud'
import Tilslagsskjermbilde from '../components/Admin/Auctions/Tilslagsskjermbilde/Tilslagsskjermbilde'
import Auksjon from '../components/Admin/Auctions/Auksjon/Auksjon'
import AuksjonForm from '../components/Admin/Auctions/Auksjon/AuksjonForm'

import Stats from '../components/Admin/Reports/Stats/Stats'
import StatsEmtpy from '../components/Admin/Reports/Stats/StatsEmpty'
import StatsSalgEksperter from '../components/Admin/Reports/Stats/StatsSalgEksperter'
import StatsSalgKategori from '../components/Admin/Reports/Stats/StatsSalgKategori'
import StatsSalgKategoriUng from '../components/Admin/Reports/Stats/StatsSalgKategoriUng'
import StatsFullobjekt from '../components/Admin/Reports/Stats/StatsFullobjekt'
import Auksjonsstatistikk from '../components/Admin/Reports/Stats/Auksjonsstatistikk'
import StatsSalgEksperterProsentandel from '../components/Admin/Reports/Stats/StatsSalgEksperterProsentandel'
import StatsProsentandelAvSalgsdagen from '../components/Admin/Reports/Stats/StatsProsentandelAvSalgsdagen'

import Vinrapport from '../components/Admin/Reports/Vinrapport'
import VinrapportGenerator from '../components/Admin/Reports/VinrapportGenerator'

import Kjoperrapport from '../components/Admin/Reports/Kjoperrapport'
import KjoperrapportGenerator from '../components/Admin/Reports/KjoperrapportGenerator'

import ObjectsPayingStorage from '../components/Admin/Reports/ObjectsPayingStorage'
import ObjectsPayingStorageList from '../components/Admin/Reports/ObjectsPayingStorageList'

import VerktoyList from '../components/Admin/Verktoy/VerktoyList'
import VerktoyKunstnerMerge from '../components/Admin/Verktoy/VerktoyKunstnerMerge'

import KnowYourCustomer from '../components/Admin/Reports/KnowYourCustomer'
import KnowYourCustomerList from '../components/Admin/Reports/KnowYourCustomerList'

Vue.use(Router)

/**
 * Before enter method to use on Guest routes
 */
const checkGuestStatus = (to, from, next) => {
  if (!store.getters.hasToken) {
    // No token, so this is ok
    next()
  } else if (!store.getters.isLoggedIn) {
    // Got token, but ain't logged in, so try to load user profile
    store.dispatch(USER_REQUEST)
      .then(() => {
        // Got it, so go to dashboard
        next('/dashboard')
      })
      .catch(() => {
        // Failed, so go to login page
        next()
      })
  }
}

/**
 * Before enter method to use on Admin routes
 */
const checkAdminStatus = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    if (to.meta && to.meta.rolle && !AvantiAccess.hasAccess(to.meta.rolle)) {
      console.log('Access failed for meta->role: ', to.meta.rolle)

      if (from.name === 'Dashboard') {
        return next({
          name: 'Dashboard',
          query: from.query.e ? '' : { e: (new Date()).getTime() }
        })
      }

      return next('/dashboard')
    } else {
      return next()
    }

    // const currentRole = store.getters.getUser && store.getters.getUser.rolle ? store.getters.getUser.rolle.slug : ''
    // if (to.meta && to.meta.rolle && !to.meta.rolle.includes(currentRole)) {
    //   return next('/dashboard')
    // } else {
    //   // Is logged in and in correct role, so continue
    //   return next()
    // }
  } else if (store.getters.hasToken) {
    // Not logged in, but got a token, so try to load user profile
    store.dispatch(USER_REQUEST)
      .then(() => {
        if (to.meta && to.meta.rolle && !AvantiAccess.hasAccess(to.meta.rolle)) {
          console.log('Access failed for meta->role: ', to.meta.rolle)
          return next('/dashboard')
        } else {
          return next()
        }

        // Got it, so go to requested page - if has correct role
        // const currentRole = store.getters.getUser && store.getters.getUser.rolle ? store.getters.getUser.rolle.slug : ''
        // if (to.meta && to.meta.rolle && !to.meta.rolle.includes(currentRole)) {
        //   return next('/dashboard')
        // } else {
        //   // Is logged in and in correct role, so continue
        //   return next()
        // }
      })
      .catch(() => {
        // Failed, so go to login page
        return next('/')
      })
  } else {
    // Not logged in, no token, so go to login page
    return next('/')
  }
}

/**
 * Create the routes
 */
let routes = [
  /**
   * Guest Routes : Not logged in
   */
  {
    path: '/',
    name: 'UserLogin',
    component: UserLogin,
    beforeEnter: checkGuestStatus
  },
  {
    path: '/glemt-passord',
    name: 'UserPasswordForgot',
    component: UserPasswordForgot,
    beforeEnter: checkGuestStatus
  },
  {
    path: '/reset-passord/:token?',
    name: 'UserPasswordReset',
    component: UserPasswordReset,
    beforeEnter: checkGuestStatus
  },
  {
    path: '/verify',
    name: 'UserVerify',
    component: UserVerify,
    beforeEnter: checkGuestStatus
  },

  /**
   * Admin Routes : Logged in
   */
  {
    path: '/dashboard',
    component: Dashboard,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {
          title: 'Dashboard'
        },
        component: DashboardPageOverview
      },
      {
        path: 'uferdige-kontrakt',
        name: 'DashboardPageUferdigeKontrakt',
        meta: {
          title: 'Dashboard - Uferdige Kontrakter'
        },
        component: DashboardPageUferdigeKontrakt
      },
      {
        path: 'uferdige-objekt',
        name: 'DashboardPageUferdigeObjekt',
        meta: {
          title: 'Dashboard - Uferdige Objekter'
        },
        component: DashboardPageUferdigeObjekt
      },
      {
        path: 'oppgaver',
        name: 'DashboardPageOppgaver',
        meta: {
          title: 'Dashboard - Oppgaver'
        },
        component: DashboardPageOppgaver
      },
      {
        path: 'oppgjor-feil',
        name: 'DashboardPageFailedOppgjor',
        meta: {
          title: 'Dashboard - Oppgjor Feil'
        },
        component: DashboardPageFailedOppgjor
      }
    ]
  },
  {
    path: '/o/:objektnr',
    name: 'ObjektnrFinder',
    meta: {
      title: ''
    },
    component: ObjektFinder,
    beforeEnter: checkAdminStatus
  },
  {
    path: '/sok-objekter',
    name: 'SearchObject',
    meta: {
      title: 'Søk objekter'
    },
    component: SearchObject,
    beforeEnter: checkAdminStatus
  },
  {
    path: '/sok-kunde',
    name: 'SearchCustomer',
    meta: {
      title: 'Søk kunde'
    },
    component: SearchCustomer,
    beforeEnter: checkAdminStatus
  },
  {
    path: '/searchredirect',
    name: 'SearchRedirect',
    component: SearchRedirect
  },
  {
    path: '/kunde',
    component: Kunde,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: 'KundeList',
        meta: {
          title: 'Kunde'
        },
        component: KundeList
      },
      {
        path: 'add',
        name: 'KundeCardAdd',
        meta: {
          title: 'Kunde - Oprett'
        },
        component: KundeCardAdd
      },
      {
        path: ':kunde_id(\\d+)',
        name: 'KundeCard',
        component: KundeCard
      },
      {
        path: ':kunde_id(\\d+)/:kontrakt_id(\\d+)/:objekt_id(\\d+)',
        name: 'KundeKontraktObjektFullscreen',
        component: KundeKontraktObjektFullscreen
      }
    ]
  },
  {
    path: '/bruker',
    component: Bruker,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: 'BrukerList',
        meta: {
          title: 'Ansatte',
          rolle: 'management'
        },
        component: BrukerList
      },
      {
        path: 'add',
        name: 'BrukerCardAdd',
        meta: {
          title: 'Ansatte - Oprett',
          rolle: 'management'
        },
        component: BrukerCardAdd
      },
      {
        path: ':bruker_id(\\d+)',
        name: 'BrukerCard',
        meta: {
          title: 'Ansatte - Rediger',
          rolle: 'management'
        },
        component: BrukerCard
      }
    ]
  },
  {
    path: '/rapporter',
    component: Reports,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: 'ReportsList',
        meta: {
          title: 'Rapporter',
          rolle: 'expert'
        },
        component: ReportsList
      },
      {
        path: 'rs-link',
        name: 'RSLink',
        meta: {
          title: 'Rapporter - Resource Space lenke',
          rolle: 'expert'
        },
        component: RSLink
      },
      {
        path: 'katalog',
        meta: {
          title: 'Rapporter - Katalog',
          rolle: 'expert'
        },
        component: Katalog,
        children: [
          {
            path: '',
            name: 'Katalog',
            meta: {
              title: 'Rapporter - Katalog - Kunder',
              rolle: 'expert'
            },
            component: KatalogKundeList
          }
        ]
      },
      {
        path: 'objectsPayingStorage',
        meta: {
          title: 'Lagerleieliste',
          rolle: 'expert'
        },
        component: ObjectsPayingStorage,
        children: [
          {
            path: '',
            name: 'ObjectsPayingStorage',
            meta: {
              title: 'Lagerleieliste',
              rolle: 'expert'
            },
            component: ObjectsPayingStorageList
          }
        ]
      },
      {
        path: 'knowYourCustomer',
        meta: {
          title: 'Know Your Customer',
          rolle: 'expert'
        },
        component: KnowYourCustomer,
        children: [
          {
            path: '',
            name: 'KnowYourCustomer',
            meta: {
              title: 'Know Your Customer List',
              rolle: 'expert'
            },
            component: KnowYourCustomerList
          }
        ]
      },
      {
        path: 'besiktigelse',
        meta: {
          title: 'Rapporter - Besiktigelse',
          rolle: 'expert'
        },
        component: Besiktigelse,
        children: [
          {
            path: '',
            name: 'Besiktigelse',
            meta: {
              title: 'Rapporter - Besiktigelse - Email',
              rolle: 'expert'
            },
            component: BesiktigelseList
          }
        ]
      },
      {
        path: 'resultatbrev',
        meta: {
          title: 'Rapporter - Resultatbrev',
          rolle: 'expert'
        },
        component: Resultatbrev,
        children: [
          {
            path: '',
            name: 'Resultatbrev',
            meta: {
              title: 'Rapporter - Resultatbrev - Ubehandlede',
              rolle: 'expert'
            },
            component: ResultatbrevUbehandlade
          },
          {
            path: 'godkjenn',
            name: 'ResultatbrevGodkjenning',
            meta: {
              title: 'Rapporter - Resultatbrev - Godkjenning',
              rolle: 'expert'
            },
            component: ResultatbrevGodkjenning
          },
          {
            path: 'historikk',
            name: 'ResultatbrevHistorikk',
            meta: {
              title: 'Rapporter - Resultatbrev - Historikk',
              rolle: 'expert'
            },
            component: ResultatbrevHistorikk
          },
          {
            path: 'ny',
            name: 'ResultatbrevNy',
            meta: {
              title: 'Rapporter - Resultatbrev - Lag ny',
              rolle: 'expert'
            },
            component: ResultatbrevNy
          }
        ]
      },
      {
        path: 'bekreftelsebrev',
        meta: {
          title: 'Rapporter - Bekreftelsebrev',
          rolle: 'expert'
        },
        component: Bekreftelsebrev,
        children: [
          {
            path: '',
            name: 'Bekreftelsebrev',
            meta: {
              title: 'Rapporter - Bekreftelsebrev - Ubehandlede',
              rolle: 'expert'
            },
            component: BekreftelsebrevUbehandlade
          },
          {
            path: 'godkjenn',
            name: 'BekreftelsebrevGodkjenning',
            meta: {
              title: 'Rapporter - Bekreftelsebrev - Godkjenning',
              rolle: 'expert'
            },
            component: BekreftelsebrevGodkjenning
          },
          {
            path: 'historikk',
            name: 'BekreftelsebrevHistorikk',
            meta: {
              title: 'Rapporter - Bekreftelsebrev - Historikk',
              rolle: 'expert'
            },
            component: BekreftelsebrevHistorikk
          },
          {
            path: 'ny',
            name: 'BekreftelsebrevNy',
            meta: {
              title: 'Rapporter - Bekreftelsebrev - Lag ny',
              rolle: 'expert'
            },
            component: BekreftelsebrevNy
          }
        ]
      },
      {
        path: 'manusliste',
        meta: {
          title: 'Rapporter - Manusliste',
          rolle: 'expert'
        },
        component: Manuslist,
        children: [
          {
            path: '',
            name: 'Manusliste',
            meta: {
              title: 'Rapporter - Manusliste for ekspertene',
              rolle: 'expert'
            },
            component: ManuslistGenerator
          },
          {
            path: 'kunde',
            name: 'ManuslisteKunde',
            meta: {
              title: 'Rapporter - Katalog/Manusliste for kunder',
              rolle: 'expert'
            },
            component: ManuslistGenerator
          }
        ]
      },
      {
        path: 'politirapport',
        meta: {
          title: 'Rapporter - Politirapport',
          rolle: 'management'
        },
        component: Politirapport,
        children: [
          {
            path: '',
            name: 'Politirapport',
            meta: {
              title: 'Rapporter - Politirapport',
              rolle: 'management'
            },
            component: PolitirapportGenerator
          }
        ]
      },
      {
        path: 'vinrapport',
        meta: {
          title: 'Rapporter - Vinrapport',
          rolle: 'expert'
        },
        component: Vinrapport,
        children: [
          {
            path: '',
            name: 'Vinrapport',
            meta: {
              title: 'Rapporter - Vinrapport',
              rolle: 'expert'
            },
            component: VinrapportGenerator
          }
        ]
      },
      {
        path: 'kjoperrapport',
        meta: {
          title: 'Rapporter - Store kunder vin',
          rolle: 'expert'
        },
        component: Kjoperrapport,
        children: [
          {
            path: '',
            name: 'Kjoperrapport',
            meta: {
              title: 'Rapporter - Store kunder vin',
              rolle: 'expert'
            },
            component: KjoperrapportGenerator
          }
        ]
      },
      {
        path: 'statistikk',
        meta: {
          title: 'Statistikk',
          rolle: 'expert'
        },
        component: Stats,
        children: [
          {
            path: '',
            name: 'Stats',
            meta: {
              title: 'Statistikk',
              rolle: 'expert'
            },
            component: StatsEmtpy
          },
          {
            path: 'salg-eksperter',
            name: 'StatsSalgEksperter',
            meta: {
              title: 'Statistikk - Salg Eksperter',
              rolle: 'management'
            },
            component: StatsSalgEksperter
          },
          {
            path: 'salg-kategorier',
            name: 'StatsSalgKategori',
            meta: {
              title: 'Statistikk - Salg Kategori',
              rolle: 'expert'
            },
            component: StatsSalgKategori
          },
          {
            path: 'salg-kategorier-ung',
            name: 'StatsSalgKategoriUng',
            meta: {
              title: 'Statistikk - Salg Kategori Ugn',
              rolle: 'expert'
            },
            component: StatsSalgKategoriUng
          },
          {
            path: 'objekt-rapport',
            name: 'StatsFullobjekt',
            meta: {
              title: 'Statistikk - Objekt Rapport',
              rolle: 'accounting'
            },
            component: StatsFullobjekt
          },
          {
            path: 'auksjonsstatistikk',
            name: 'Auksjonsstatistikk',
            meta: {
              title: 'Statistikk - Auksjonsstatistikk',
              rolle: 'expert'
            },
            component: Auksjonsstatistikk
          },
          {
            path: 'salg-eksperter-prosentandel',
            name: 'StatsSalgEksperterProsentandel',
            meta: {
              title: 'Statistikk - Prosentandel salgseksperter'
              // rolle: 'management'
            },
            component: StatsSalgEksperterProsentandel
          },
          {
            path: 'stats-prosentandel-salgsdagen',
            name: 'StatsProsentandelAvSalgsdagen',
            meta: {
              title: 'Statistikk - Prosentandel Av Salgsdagen'
            },
            component: StatsProsentandelAvSalgsdagen
          },
          {
            path: 'gjenstander-klare-for-auksjon',
            name: 'GjenstanderKlareForAuksjon',
            meta: {
              title: 'Gjenstander Klare For Auksjon'
            },
            component: GjenstanderKlareForAuksjon
          },
          {
            path: 'vinpakkeliste',
            name: 'Vinpakkeliste',
            meta: {
              title: 'Pakkeliste, vin'
            },
            component: Vinpakkeliste
          }
        ]
      }
    ]
  },
  {
    path: '/auksjoner',
    component: Auctions,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: 'AuctionsList',
        meta: {
          title: 'Auksjoner',
          rolle: 'consultant'
        },
        component: AuctionsList
      },
      {
        path: 'forhandsbud',
        name: 'Forhandsbud',
        meta: {
          title: 'Auksjoner - Forhåndsbud',
          rolle: 'expert'
        },
        component: Forhandsbud
      },
      {
        path: 'spader',
        name: 'Spader',
        meta: {
          title: 'Auksjoner - Spader',
          rolle: 'expert'
        },
        component: Spader
      },
      {
        path: 'telefonbud',
        name: 'Telefonbud',
        meta: {
          title: 'Auksjoner - Telefonbud',
          rolle: 'expert'
        },
        component: Telefonbud
      },
      {
        path: 'tilslagsskjermbilde',
        name: 'Tilslagsskjermbilde',
        meta: {
          title: 'Auksjoner - Tilslagsskjermbilde',
          rolle: 'consultant'
        },
        component: Tilslagsskjermbilde
      },
      {
        path: 'auksjon/:avdeling',
        name: 'Auksjon',
        meta: {
          title: 'Auksjoner - Auksjon',
          rolle: 'expert'
        },
        component: Auksjon
      },
      {
        path: 'auksjon/:avdeling/edit/:id?',
        name: 'AuksjonForm',
        meta: {
          title: 'Auksjoner - Edit Auksjon',
          rolle: 'expert'
        },
        component: AuksjonForm
      }
    ]
  }
]

if (process.env.VUE_APP_AVANTI_ENV !== 'production') {
  routes.push(
    {
      path: '/playground',
      name: 'Playground',
      meta: {
        title: 'Playground'
      },
      component: Playground,
      beforeEnter: checkAdminStatus
    }
  )
}

/**
 * Create all the Instillninger
 */
routes.push({
  path: '/instillinger',
  component: Instillinger,
  beforeEnter: checkAdminStatus,
  children: [
    {
      path: '',
      name: 'InstillingerList',
      meta: {
        title: 'Innstillinger',
        rolle: 'admin'
      },
      component: InstillingerList
    }
  ]
})

/** Special section for labels */
routes.push({
  path: '/instillinger/label',
  component: InstillingerLabel,
  meta: {
    title: 'Instillinger - Label',
    rolle: 'admin'
  },
  beforeEnter: checkAdminStatus,
  children: [
    {
      path: '',
      name: 'Label',
      meta: {
        title: 'Instillinger - Label Kunst / Nett',
        rolle: 'admin'
      },
      component: InstillingerLabelArt,
      beforeEnter: checkAdminStatus
    },
    {
      path: 'vin',
      name: 'LabelWine',
      meta: {
        title: 'Instillinger - Label Vin',
        rolle: 'admin'
      },
      component: InstillingerLabelWine,
      beforeEnter: checkAdminStatus
    }
  ]
})

let typeRoutes = [
  { path: 'auksjontype', name: 'Auksjon', full: 'AuksjonType' },
  { path: 'objekttype', name: 'Objekt', full: 'ObjektType' },
  { path: 'kontrakttype', name: 'Kontrakt', full: 'KontraktType' },
  { path: 'varetype', name: 'Vare', full: 'VareType' },
  { path: 'kvitteringtype', name: 'Kvittering', full: 'KvitteringType' },
  { path: 'labeltype', name: 'Label', full: 'LabelType' },
  { path: 'bilagtype', name: 'Bilag', full: 'BilagType' },
  { path: 'bilagart', name: 'Bilagart', full: 'BilagartType' }
]

for (let i = 0; i < typeRoutes.length; ++i) {
  let r = typeRoutes[i]

  routes.push({
    path: '/instillinger/' + r.path,
    component: Instillinger,
    beforeEnter: checkAdminStatus,
    children: [
      {
        path: '',
        name: r.full + 'List',
        meta: {
          title: 'Instillinger - ' + r.full
        },
        component: InstillingerTypeList,
        props: { name: r.name, servicename: r.path },
        beforeEnter: checkAdminStatus
      },
      {
        path: 'add',
        name: r.full + 'Add',
        meta: {
          title: 'Instillinger - ' + r.full + ' - Opprett'
        },
        component: InstillingerTypeEdit,
        props: { name: r.name, servicename: r.path },
        beforeEnter: checkAdminStatus
      },
      {
        path: ':id(\\d+)',
        name: r.full + 'Edit',
        meta: {
          title: 'Instillinger - ' + r.full + ' - Rediger'
        },
        component: InstillingerTypeEdit,
        props: { name: r.name, servicename: r.path },
        beforeEnter: checkAdminStatus
      }
    ]
  })
}

let otherRoutes = [
  { path: 'auksjon', name: 'Auksjon', keys: [], list: InstillingerAuksjonList, create: InstillingerAuksjonEdit, update: InstillingerAuksjonEdit },
  { path: 'kunstner', name: 'Kunstner', keys: ['Idnr', 'Navn', 'Periode', 'Opprettet'], create: InstillingerKunstnerEdit, update: InstillingerKunstnerEdit },
  { path: 'avdeling', name: 'Avdeling', keys: ['Avdelingsid', 'Navn', 'Beskrivelse'], create: false, update: false },
  { path: 'expertavdeling', name: 'Expertavdeling', keys: ['id', 'Avdelingsid', 'Navn'], create: InstillingerExpertavdelingEdit, update: InstillingerExpertavdelingEdit },
  { path: 'land', name: 'Land', keys: ['Landkode', 'Kategori', 'Landbeskrivelse', 'Isokode'], create: false, update: InstillingerLandEdit },
  { path: 'postreg', name: 'Postreg', keys: ['Postnr', 'Poststed', 'Kommunenr', 'Kommune'], create: false, update: false },
  { path: 'legitimasjon', name: 'Legitimasjon', keys: ['Id', 'Tekst', 'sortering'], create: InstillingerLegitimasjonEdit, update: InstillingerLegitimasjonEdit },
  { path: 'lokasjon', name: 'Lokasjon', keys: ['Lokasjonid', 'Lokasjonkode', 'Beskrivelse', 'Avdeling', 'object_count'], create: InstillingerLokasjonEdit, update: InstillingerLokasjonEdit },
  { path: 'mva', name: 'Mva', keys: ['Mvaid', 'Mvakode', 'Mvapct', 'Mvatype', 'Navimvakode'], create: InstillingerMvaEdit, update: InstillingerMvaEdit },
  { path: 'selskap', name: 'Selskap', keys: ['Selskapsid', 'Selskapskode', 'Beskrivelse'], create: false, update: false },
  { path: 'betalingsart', name: 'Betalingsart', keys: ['Betalingsartid', 'Betalingsartkode', 'Beskrivelse', 'Passiv'], create: InstillingerBetalingsartEdit, update: InstillingerBetalingsartEdit },
  { path: 'objektsignert', name: 'Objektsignert', keys: ['ID', 'Beskrivelse', 'Engelsk', 'Prioritet', 'Aktiv'], create: InstillingerObjektsignertEdit, update: InstillingerObjektsignertEdit },
  { path: 'objektbeskrivelse', name: 'Objektbeskrivelse', keys: ['Objektbeskrivelseid', 'Beskrivelse', 'Engelsk'], create: InstillingerObjektbeskrivelseEdit, update: InstillingerObjektbeskrivelseEdit },
  // {path: 'label', name: 'Label', keys: [ 'Labelid', 'Navn', 'Engelsk', 'Dato', 'Parent', 'Kategori', 'labeltype' ], create: InstillingerLabelEdit, update: InstillingerLabelEdit},
  { path: 'dokumenttype', name: 'Dokumenttype', keys: ['Dokumenttypeid', 'Dokumentkode', 'Beskrivelse', 'Vareid'], create: InstillingerDokumenttypeEdit, update: InstillingerDokumenttypeEdit },
  { path: 'kategori', name: 'Kategori', keys: ['Kategoriid', 'Kategori', 'Beskrivelse', 'Info', 'Avdelingsid', 'Expertavdeling', 'Mvaid', 'twentyfourseven_category_id'], create: InstillingerKategoriEdit, update: InstillingerKategoriEdit },
  { path: 'kundekategoritype', name: 'Kundekategoritype', keys: ['Kundekategoritypeid', 'Kategorikode', 'Beskrivelse', 'Dokumenttypeid'], create: InstillingerKundekategoritypeEdit, update: InstillingerKundekategoritypeEdit },
  { path: 'vare', name: 'Vare', keys: ['Vareid', 'Varekode', 'Beskrivelse', 'Pris', 'Prisinclmva', 'Enhetskode', 'Mvakode', 'Bokforgruppekode', 'Bilagsart', 'Status', 'twentyfourseven_product_id'], create: InstillingerVareEdit, update: InstillingerVareEdit },
  { path: 'vareenhet', name: 'Vareenhet', keys: ['Vareenhetid', 'Enhetskode', 'Beskrivelse'], create: InstillingerVareenhetEdit, update: InstillingerVareenhetEdit },
  { path: 'bokforgruppe', name: 'Bokforgruppe', keys: ['Bokforgruppeid', 'Bokforgruppekode', 'Beskrivelse', 'Kontomvaexport', 'Kontomvafri', 'Kontomva', 'Kontomotkonto', 'Kontomellom', 'Kontomellommvafri', 'Kunstneravgift', 'Kunstavggrl', 'KunstavggrlMotkonto'], create: InstillingerBokforgruppeEdit, update: InstillingerBokforgruppeEdit },
  { path: 'fraktgruppe', name: 'Fraktgruppe', keys: ['Fraktgruppeid', 'Kode', 'Beskrivelse', 'Passiv', 'Vareid'], create: InstillingerFraktgruppeEdit, update: InstillingerFraktgruppeEdit },
  { path: 'freighttype', name: 'Freighttype', keys: ['id', 'Name', 'ZipCode', 'Price', 'Comment'], create: InstillingerFreighttypeEdit, update: InstillingerFreighttypeEdit },
  { path: 'utelagringsdager', name: 'Utelagringsdager', keys: ['id', 'Description', 'StartDate', 'EndDate', 'Comment'], create: InstillingerUtelagringsdagerEdit, update: InstillingerUtelagringsdagerEdit },
  { path: 'merknad', name: 'Merknad', keys: ['id', 'Tekst', 'Expertavdelingsid'], create: InstillingerMerknadEdit, update: InstillingerMerknadEdit },
  { path: 'printer', name: 'Printer', keys: ['id', 'Identifier', 'Navn', 'Labeltypes'], create: InstillingerPrinterEdit, update: InstillingerPrinterEdit },
  { path: 'bilagsoverforing', name: 'Bilagsoverforing', keys: ['id', 'Identifier', 'Navn', 'Labeltypes'], create: InstillingerBilagsoverforingEdit, update: InstillingerBilagsoverforingEdit },
  { path: 'oppgjordebug', name: 'Oppgjordebug', keys: ['id', 'Identifier', 'Navn', 'Labeltypes'], create: InstillingerOppgjordebugEdit, update: InstillingerOppgjordebugEdit },
  { path: 'autochargeinterval', name: 'Autochargeinterval', keys: ['id', 'Dato', 'Intervall'], create: InstillingerAutochargeintervalEdit, update: InstillingerAutochargeintervalEdit }
]

for (let i = 0; i < otherRoutes.length; ++i) {
  let r = otherRoutes[i]

  let children = []
  children.push({
    path: '',
    name: r.name + 'List',
    meta: {
      title: 'Instillinger - ' + r.name
    },
    component: r.list ? r.list : InstillingerCustomList,
    props: { name: r.name, servicename: r.path, keys: r.keys, perms: { update: !!r.update, create: !!r.create } },
    beforeEnter: checkAdminStatus
  })

  if (r.create) {
    children.push({
      path: 'add',
      name: r.name + 'Add',
      meta: {
        title: 'Instillinger - ' + r.name + ' - Opprett'
      },
      component: r.create,
      props: { name: r.name, servicename: r.path, keys: r.keys },
      beforeEnter: checkAdminStatus
    })
  }

  if (r.update) {
    children.push({
      path: ':id',
      name: r.name + 'Edit',
      meta: {
        title: 'Instillinger - ' + r.name + ' - Rediger'
      },
      component: r.update,
      props: { name: r.name, servicename: r.path, keys: r.keys },
      beforeEnter: checkAdminStatus
    })
  }

  routes.push({
    path: '/instillinger/' + r.path,
    component: Instillinger,
    beforeEnter: checkAdminStatus,
    children: children
  })
}

/**
 * Create all the Verktøy
 */
routes.push({
  path: '/verktoy',
  component: Instillinger,
  beforeEnter: checkAdminStatus,
  children: [
    {
      path: '',
      name: 'VerktoyList',
      meta: {
        title: 'Verktøy',
        rolle: 'admin'
      },
      component: VerktoyList
    },
    {
      path: 'merge-artirts',
      name: 'VerktoyKunstnerMerge',
      meta: {
        title: 'Merge Artists',
        rolle: 'admin'
      },
      component: VerktoyKunstnerMerge
    }
  ]
})

/**
 * Last but not least add a 404 page
 */
routes.push(
  {
    path: '*',
    component: PageNotFound
    // beforeEnter: checkAdminStatus
  }
)

let router = new Router({
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active'
})

/**
 * Progress bar on page loads
 */
router.beforeEach((to, from, next) => {
  store.commit(SET_PAGE_LOADING, true)

  // If have a title in meta - we set it.
  if (to.meta && to.meta.title) {
    document.title = 'Avanti - ' + to.meta.title
  }

  if (!NProgress.isStarted()) {
    NProgress.start()
  }

  next()
})

router.afterEach((to, from) => {
  if (NProgress.isStarted()) {
    store.commit(SET_PAGE_LOADING, false)
    NProgress.done()

    // Refresh Auth?
    if (store.getters.isLoggedIn && (from.fullPath !== to.fullPath)) {
      store.dispatch('AUTH_REFRESH')
        .catch((err) => {
          console.log('Error from Token Refresh', err)
        })
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js